<template>
  <div id="pie" :style="{ width: width + 'px', height: height + 'px' }"></div>
</template>

<script>
let echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/pie");

export default {
  name: "pie",
  props: {
    volume_data: [Array, Object],
    width: Number,
    height: Number,
    is_loading: Boolean,
  },
  data() {
    return {
      chart: {},
    };
  },
  watch: {
    volume_data(new_val) {
      this.chart.showLoading();
      this.volume_data = new_val;
      this.draw();
    },
    is_loading(new_val) {
      new_val ? this.chart.showLoading() : this.chart.hideLoading();
    },
  },
  mounted() {
    this.chart = echarts.init(document.getElementById("pie"));
    this.chart.showLoading();
  },
  methods: {
    draw() {
      let seriesData = [];
      for (let project of this.volume_data) {
        seriesData.push({
          name: project.propulsionType,
          value: project.volume,
        });
      }

      const option = {
        color: [
          "#3F76F6",
          "#6BBC6C",
          "#5D7092",
          "#FEAA2D",
          "#E8684A",
          "#6DC8EC",
          "#5370C6",
          "#4CA7F5",
        ],
        tooltip: {
          trigger: "item",
          borderColor: "#FFFFFF",
          formatter: (param) => {
            let list = [];
            if(param)
            {
              list.push('<span style="font-size:12px;color:#6e7079;margin-left:2px">' + param?.name + '</span><div style="clear:both"></div>')
            }
            let listItem = "";
            list.push(
              param.marker +
                '<span style="font-size:12px;color:#6e7079;margin-left:2px">' +
                param.seriesName
                +
                '</span>：' +
                '<span style="font-size:12px;margin-left:5px;">' +
                param.value.toLocaleString() +
                "</span>" +
                '<div style="clear:both"></div>'
            );
            listItem = list.join("");
            return listItem;
          },
        },
        legend: {
          type: "scroll",
          icon: "circle",
          bottom: 1,
          left: "center",
          padding: [20, 52, 20, 52],
          itemWidth : 20,
          itemHeight : 10,
        },
        series: [
          {
            name: "动力形式",
            type: "pie",
            radius: ["45%", "65%"],
            center: ["50%", "45%"],
            // avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
              formatter: ["{b}", "{d}%"].join("\n")
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "20",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: seriesData,
          },
        ],
      };
      this.chart.setOption(option, true);
      this.chart.hideLoading();
      this.chart.dispatchAction({
        type: "showTip",
        seriesIndex: 0,
        dataIndex: 0,
      });
    },
  },
};
</script>
